var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLikeOnLarge = function SvgIconLikeOnLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.054 3a5.617 5.617 0 0 0-4.888 2.832A5.617 5.617 0 0 0 7.278 3c-3.1 0-5.612 2.846-5.612 5.915 0 7.708 10.5 13.085 10.5 13.085s10.5-5.377 10.5-13.085C22.666 5.846 20.153 3 17.054 3Z",
    fill: "#DD3955"
  })));
};
export default SvgIconLikeOnLarge;